export const apiBase = `/api/hall-of-service`;
// export const apiBase = `http://localhost:8080/api/hall-of-service`;
